import React, { useEffect, useState } from 'react';
import ListaLinksScroleable from '../UI/ListaLinksScroleable';
import MensajeCargando from '../UI/MensajeCargando';
import MensajeError from '../UI/MensajeError';
import useGetListaURL from '../../hooks/useGetListaURL';

const ListaPaisesConfederacion = (props) => {
  const idConfederacion = props.confederacion && props.confederacion.id;
  const pathLinks = props.pathLinks;
  const [paises, setPaises] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchData('parametros/confederaciones/' + idConfederacion + '/paises', setPaises);
  }, [idConfederacion, fetchData]);

  return (
    <React.Fragment>
      <ListaLinksScroleable path={pathLinks} lista={paises} cantVisibles={6} altoFijo={true} />
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ListaPaisesConfederacion;
